<template>
  <div>
    <h2 class="page-title text-center">{{ $route.params.id ? 'Detail' : 'Tambah' }} Penilaian Pelaksanaan Pusat</h2>
    <Widget customHeader>
      <form-tabs ref="formTabs" v-model="activeTab" :before-change="konfirmasiPindahTab">
        <form-tab title="Identitas" :indicator="indicatorIdentitasClass(form.identitas)">
          <form-identitas
            ref="formIdentitas"
            v-model="form.identitas"
            @reload="loadTitikKoordinat"
            @kembali="kembaliKeDaftar"
            @selanjutnya="keTabBerikutnya"
            @simpan="simpanTab('identitas')"
          />
        </form-tab>

        <form-tab title="Kemajuan Perizinan" :indicator="indicatorKemajuanPerizinanClass(form.kemajuanPerizinan)">
          <form-kemajuan-perizinan
            ref="formKemajuanPerizinan"
            v-model="form.kemajuanPerizinan"
            :is-active="activeTab === 1"
            @kembali="keTabSebelumnya"
            @selanjutnya="keTabBerikutnya"
            @simpan="simpanTab('kemajuanPerizinan')"
          />
        </form-tab>

        <form-tab title="Kewajiban" :indicator="indicatorKewajibanClass(form.kewajiban)">
          <form-kewajiban
            ref="formKewajiban"
            v-model="form.kewajiban"
            :informasi-kewajiban="informasiKewajiban"
            @kembali="keTabSebelumnya"
            @selanjutnya="keTabBerikutnya"
            @simpan="simpanTab('kewajiban')"
          />
        </form-tab>

        <form-tab title="Wawancara" :indicator="indicatorWawancaraClass(form.wawancara)">
          <form-wawancara
            ref="formWawancara"
            v-model="form.wawancara"
            @kembali="keTabSebelumnya"
            @selanjutnya="keTabBerikutnya"
            @simpan="simpanTab('wawancara')"
          />
        </form-tab>

        <form-tab title="Berita Acara" :indicator="indicatorBeritaAcaraClass(form.beritaAcara)">
          <form-berita-acara
            ref="formBeritaAcara"
            v-model="form.beritaAcara"
            @kembali="keTabSebelumnya"
            @selanjutnya="keTabBerikutnya"
            @simpan="simpanTab('beritaAcara')"
          />
        </form-tab>

        <form-tab title="Finalisasi" :indicator="indicatorFinalisasiClass(form.finalisasi)">
          <form-finalisasi
            v-model="form.finalisasi"
            @kembali="keTabSebelumnya"
            @simpan="simpanTab('finalisasi')"
            @submit="submitForm"
          />
        </form-tab>
      </form-tabs>
    </Widget>
    <b-modal
      v-model="showIncompleteTabsModal"
      title="Form Belum Lengkap"
      ok-only
      ok-title="Tutup"
      ok-variant="secondary"
    >
      <p>Lengkapi field wajib pada tab berikut sebelum Submit:</p>
      <ol class="mb-0">
        <li v-for="tabName in incompleteTabNames" :key="tabName">{{ tabName }}</li>
      </ol>
    </b-modal>
  </div>
</template>

<script>
import formIdentitas from './formIdentitas.vue'
import formKemajuanPerizinan from './formKemajuanPerizinan.vue'
import formKewajiban from './formKewajiban.vue'
import formWawancara from './formWawancara.vue'
import formBeritaAcara from './formBeritaAcara.vue'
import formFinalisasi from './formFinalisasi.vue'
import FormTabs from '@/components/FormTabs/FormTabs.vue'
import FormTab from '@/components/FormTabs/FormTab.vue'
import { createEmptyWawancaraNarasumber, wawancaraQuestionGroups } from './wawancaraQuestions'
import { createEmptyKewajiban, kewajibanItems } from './kewajibanItems'
import { STATUS_RENCANA_AKSI } from '@/consts/consts'
import api from '@/services/api'
import Swal from 'sweetalert2'

const IDENTITAS_FIELDS = [
  'nomor_kkprl',
  'jenis_kegiatan',
  'npwp',
  'subjek_hukum',
  'nib',
  'provinsi',
  'tanggal_terbit',
  'nama_kegiatan',
  'nama_detail_kegiatan',
  'luas',
  'panjang',
  'nama_perairan',
  'nama_kawasan_rtr',
  'dasar_hukum_rtr',
  'keterangan_realisasi',
]

const LAPORAN_TAHUNAN_IDENTITAS_FIELDS = {
  nomor_kkprl: 'nomor_kkprl',
  jenis_kegiatan: 'jenis_kegiatan',
  npwp: 'npwp',
  subjek_hukum: 'nama_pemegang',
  nib: 'nib',
  provinsi: 'provinsi',
  tanggal_terbit: 'tanggal_penerbitan',
  nama_detail_kegiatan: 'detail_kegiatan',
  luas: 'realisasi_luas',
  panjang: 'realisasi_panjang',
  nama_perairan: 'nama_perairan',
}

const WAWANCARA_FIELD_MAP = {
  pelaku_usaha: {
    tanggal_wawancara: 'tanggal_wawancara_pelaku_usaha',
    waktu_mulai: 'waktu_mulai_wawancara_pelaku_usaha',
    waktu_selesai: 'waktu_selesai_wawancara_pelaku_usaha',
    zona_waktu: 'zona_waktu_wawancara_pelaku_usaha',
    lokasi: 'lokasi_wawancara_pelaku_usaha',
    nama_narasumber: 'nama_narasumber_pelaku_usaha',
    alamat_narasumber: 'alamat_narasumber_pelaku_usaha',
    no_surat_tugas_kuasa: 'nomor_surat_tugas_kuasa_pelaku_usaha',
    catatan: 'catatan_wawancara_pelaku_usaha',
  },
  masyarakat: {
    tanggal_wawancara: 'tanggal_wawancara_masyarakat',
    waktu_mulai: 'waktu_mulai_wawancara_masyarakat',
    waktu_selesai: 'waktu_selesai_wawancara_masyarakat',
    zona_waktu: 'zona_waktu_wawancara_masyarakat',
    lokasi: 'lokasi_wawancara_masyarakat',
    nama_narasumber: 'nama_narasumber_masyarakat',
    alamat_narasumber: 'alamat_narasumber_masyarakat',
    no_surat_tugas_kuasa: 'nomor_surat_tugas_kuasa_masyarakat',
    catatan: 'catatan_wawancara_masyarakat',
  },
}

const BERITA_ACARA_FIELD_MAP = {
  tanggal_ba: 'tanggal_ba',
  nomor_ba: 'nomor_ba',
  provinsi: 'provinsi_ba',
  kabupaten: 'kabupaten_kota_ba',
  kecamatan: 'kecamatan_ba',
  kelurahan: 'kelurahan_ba',
  isi_berita_acara: 'isi_berita_acara',
}

const FINALISASI_FIELDS = [
  'persentase_realisasi',
  'kriteria',
  'kategori',
  'luas_area_infrastruktur',
  'persentase_area_infrastruktur',
  'luas_area_non_infrastruktur',
  'persentase_area_non_infrastruktur',
  'kriteria_subjek_hukum',
  'kategori_subjek_hukum',
  'kriteria_persetujuan',
  'kategori_persetujuan',
  'kriteria_kewajiban_kkprl',
  'kategori_kewajiban_kkprl',
  'hasil_penilaian',
]

export default {
  name: 'formPenilaianPelaksanaanPusat',
  components: {
    FormTabs,
    FormTab,
    formIdentitas,
    formKemajuanPerizinan,
    formKewajiban,
    formWawancara,
    formBeritaAcara,
    formFinalisasi,
  },
  data() {
    return {
      activeTab: 0,
      showIncompleteTabsModal: false,
      incompleteTabNames: [],
      tabKeyByIndex: {
        0: 'identitas',
        1: 'kemajuanPerizinan',
        2: 'kewajiban',
        3: 'wawancara',
        4: 'beritaAcara',
        5: 'finalisasi',
      },
      informasiKewajiban: [],
      form: {
        identitas: {
          nomor_kkprl: '',
          jenis_kegiatan: '',
          npwp: '',
          subjek_hukum: '',
          nib: '',
          provinsi: [],
          tanggal_terbit: '',
          nama_kegiatan: '',
          nama_detail_kegiatan: '',
          luas: '',
          panjang: '',
          nama_perairan: '',
          nama_kawasan_rtr: '',
          dasar_hukum_rtr: '',
          keterangan_realisasi: '',
          bukti_dukung: null,
          id_file_bukti_dukung: null,
          titik_koordinat: [],
        },
        kemajuanPerizinan: {
          perizinan: [{ id: 1, kategori: '', nama_izin: '', nomor_izin: '', tanggal_terbit: '', masa_berlaku: '' }],
          jenis_area: '',
          koordinat_perizinan: [],
        },
        kewajiban: createEmptyKewajiban(),
        wawancara: {
          pelaku_usaha: createEmptyWawancaraNarasumber(),
          masyarakat: createEmptyWawancaraNarasumber(),
        },
        beritaAcara: {
          tanggal_ba: '',
          nomor_ba: '',
          provinsi: '',
          kabupaten: '',
          kecamatan: '',
          kelurahan: '',
          isi_berita_acara: '',
          penandatangan: [
            {
              id: 1,
              serverId: null,
              kategori: '',
              nama: '',
              jabatan: '',
              instansi_unit_kerja: '',
            },
          ],
          dokumentasi: [],
          lampiran_peta_penilaian: [],
        },
        finalisasi: {
          persentase_realisasi: '',
          kriteria: '',
          kategori: '',
          luas_area_infrastruktur: '',
          persentase_area_infrastruktur: '',
          luas_area_non_infrastruktur: '',
          persentase_area_non_infrastruktur: '',
          kriteria_subjek_hukum: '',
          kategori_subjek_hukum: '',
          kriteria_persetujuan: '',
          kategori_persetujuan: '',
          kriteria_kewajiban_kkprl: '',
          kategori_kewajiban_kkprl: '',
          hasil_penilaian: '',
          catatan: '',
          tim_penilai: [],
        },
      },
    }
  },
  computed: {
    idRencanaAksi() {
      return this.$route.params.id || this.$route.query.id_rencana_aksi || ''
    },
  },
  async mounted() {
    await this.loadPelaksanaanPenilaian()
    await this.loadLaporanTahunanIdentitas()
    await this.loadTitikKoordinat()
    await this.loadKemajuanPerizinan()
    await this.loadInformasiKewajiban()
  },
  methods: {
    indicatorClass(form) {
      const isComplete = Object.values(form).every((value) => String(value || '').trim() !== '')
      return isComplete ? 'text-success' : 'text-danger'
    },
    indicatorFinalisasiClass(form) {
      const requiredFields = [
        'persentase_realisasi',
        'kriteria',
        'kategori',
        'luas_area_infrastruktur',
        'persentase_area_infrastruktur',
        'luas_area_non_infrastruktur',
        'persentase_area_non_infrastruktur',
        'kriteria_subjek_hukum',
        'kategori_subjek_hukum',
        'kriteria_persetujuan',
        'kategori_persetujuan',
        'kriteria_kewajiban_kkprl',
        'kategori_kewajiban_kkprl',
      ]
      const hasRequiredValues = requiredFields.every(
        (field) => String(form[field] === undefined || form[field] === null ? '' : form[field]).trim() !== '',
      )
      const numericFields = [
        ['persentase_realisasi', true],
        ['luas_area_infrastruktur', false],
        ['persentase_area_infrastruktur', true],
        ['luas_area_non_infrastruktur', false],
        ['persentase_area_non_infrastruktur', true],
      ]
      const numericValuesAreValid = numericFields.every(([field, isPercentage]) => {
        const value = String(form[field] === undefined || form[field] === null ? '' : form[field]).trim()
        return /^\d+(\.\d{1,2})?$/.test(value) && (!isPercentage || Number(value) <= 100)
      })
      const choiceValuesAreValid = [
        ['kriteria', ['Sesuai', 'Tidak Sesuai']],
        ['kategori', ['Taat', 'Tidak Taat']],
        ['kriteria_subjek_hukum', ['Sesuai', 'Tidak Sesuai']],
        ['kategori_subjek_hukum', ['Taat', 'Tidak Taat']],
        ['kriteria_persetujuan', ['Sesuai', 'Tidak Sesuai']],
        ['kategori_persetujuan', ['Taat', 'Tidak Taat']],
        ['kriteria_kewajiban_kkprl', ['Dilaksanakan', 'Tidak Dilaksanakan']],
        ['kategori_kewajiban_kkprl', ['Taat', 'Tidak Taat']],
      ].every(([field, options]) => options.includes(form[field]))
      const hasValidResult = ['Taat', 'Taat dengan Catatan', 'Tidak Taat'].includes(form.hasil_penilaian)
      const hasCatatan = this.hasRichTextContent(form.catatan)
      const timPenilaiIsComplete =
        Array.isArray(form.tim_penilai) &&
        form.tim_penilai.length > 0 &&
        form.tim_penilai.every((idUser) => idUser !== null && idUser !== undefined && String(idUser).trim() !== '')
      return hasRequiredValues &&
        numericValuesAreValid &&
        choiceValuesAreValid &&
        hasValidResult &&
        hasCatatan &&
        timPenilaiIsComplete
        ? 'text-success'
        : 'text-danger'
    },
    indicatorBeritaAcaraClass(form) {
      const textFields = ['tanggal_ba', 'nomor_ba', 'provinsi', 'kabupaten', 'kecamatan', 'kelurahan']
      const hasRequiredFields = textFields.every((field) => String(form[field] || '').trim() !== '')
      const validCategories = ['Penilai', 'Penanggung Jawab Pemrakarsa']
      const signatoriesAreComplete =
        Array.isArray(form.penandatangan) &&
        form.penandatangan.length > 0 &&
        form.penandatangan.every(
          (signatory) =>
            validCategories.includes(signatory.kategori) &&
            String(signatory.nama || '').trim() !== '' &&
            String(signatory.jabatan || '').trim() !== '' &&
            String(signatory.instansi_unit_kerja || '').trim() !== '',
        )
      return hasRequiredFields && this.hasRichTextContent(form.isi_berita_acara) && signatoriesAreComplete
        ? 'text-success'
        : 'text-danger'
    },
    indicatorKewajibanClass(form) {
      const items = Array.isArray(form.items) ? form.items : []
      const allAssessmentsAreComplete = kewajibanItems.every((kewajiban) => {
        const item = items.find((entry) => entry.id === kewajiban.id)
        return item && ['Sesuai', 'Tidak Sesuai'].includes(item.hasil_penilaian)
      })

      return allAssessmentsAreComplete ? 'text-success' : 'text-danger'
    },
    isWawancaraNarasumberComplete(data) {
      const hasValidTimeRange = data.waktu_mulai && data.waktu_selesai && data.waktu_selesai > data.waktu_mulai
      const isComplete = Boolean(
        String(data.tanggal_wawancara || '').trim() &&
          hasValidTimeRange &&
          ['WIB', 'WITA', 'WIT'].includes(data.zona_waktu) &&
          String(data.lokasi || '').trim() &&
          data.pewawancara !== null &&
          data.pewawancara !== undefined &&
          data.pewawancara !== '' &&
          String(data.nama_narasumber || '').trim() &&
          String(data.alamat_narasumber || '').trim() &&
          this.hasRichTextContent(data.catatan),
      )
      const answersAreComplete = wawancaraQuestionGroups.every((group) =>
        group.questions.every((question) => {
          const entry = (data.jawaban_pertanyaan || {})[question.id]
          if (!entry || !String(entry.penjelasan || '').trim()) return false
          if (group.answerType === 'conformity') return ['Sesuai', 'Tidak Sesuai'].includes(entry.jawaban)
          if (group.answerType === 'completion') return ['Sudah', 'Belum Dilaksanakan'].includes(entry.jawaban)
          return String(entry.jawaban || '').trim() !== ''
        }),
      )
      return isComplete && answersAreComplete
    },
    indicatorWawancaraClass(form) {
      return this.isWawancaraNarasumberComplete(form.pelaku_usaha) &&
        this.isWawancaraNarasumberComplete(form.masyarakat)
        ? 'text-success'
        : 'text-danger'
    },
    hasRichTextContent(content) {
      const text = String(content || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;|&#160;|&#xA0;|&ensp;|&emsp;|&thinsp;/gi, ' ')
      return text.trim() !== ''
    },
    indicatorKemajuanPerizinanClass(form) {
      const perizinanIsComplete =
        Array.isArray(form.perizinan) &&
        form.perizinan.length >= 1 &&
        form.perizinan.every((izin) => {
          const masaBerlaku = Number(izin.masa_berlaku)
          return (
            String(izin.kategori || '').trim() !== '' &&
            String(izin.nama_izin || '').trim() !== '' &&
            String(izin.nomor_izin || '').trim() !== '' &&
            String(izin.tanggal_terbit || '').trim() !== '' &&
            Number.isFinite(masaBerlaku) &&
            masaBerlaku > 0
          )
        })

      const hasValidJenisArea = ['Luas', 'Panjang'].includes(form.jenis_area)
      const minimumKoordinat = form.jenis_area === 'Luas' ? 3 : 2
      const koordinat = Array.isArray(form.koordinat_perizinan) ? form.koordinat_perizinan : []
      const koordinatCukup = koordinat.length >= minimumKoordinat
      const koordinatTerisi = koordinat.every((point) => this.isCoordinateFilled(point))
      const areaIsValid =
        hasValidJenisArea &&
        koordinatCukup &&
        koordinatTerisi &&
        (form.jenis_area === 'Luas'
          ? this.isValidCoordinatePolygon(koordinat)
          : this.isValidCoordinatePolyline(koordinat))

      return perizinanIsComplete && areaIsValid ? 'text-success' : 'text-danger'
    },
    isCoordinateFilled(point) {
      const bujur = String(point.bujur === null || point.bujur === undefined ? '' : point.bujur).trim()
      const lintang = String(point.lintang === null || point.lintang === undefined ? '' : point.lintang).trim()
      return bujur !== '' && lintang !== ''
    },
    isValidCoordinatePolygon(coordinates) {
      if (
        coordinates.length < 3 ||
        !coordinates.every(
          (point) =>
            Number.isFinite(Number(point.bujur)) &&
            Number(point.bujur) >= -180 &&
            Number(point.bujur) <= 180 &&
            Number.isFinite(Number(point.lintang)) &&
            Number(point.lintang) >= -90 &&
            Number(point.lintang) <= 90,
        )
      )
        return false

      const points = coordinates.map((point) => [Number(point.lintang), Number(point.bujur)])
      if (new Set(points.map((point) => point.join(','))).size < 3) return false

      let areaSum = 0
      points.forEach((point, index) => {
        const next = points[(index + 1) % points.length]
        const latitude = (point[0] * Math.PI) / 180
        const nextLatitude = (next[0] * Math.PI) / 180
        let longitudeDifference = ((next[1] - point[1]) * Math.PI) / 180
        if (longitudeDifference > Math.PI) longitudeDifference -= 2 * Math.PI
        if (longitudeDifference < -Math.PI) longitudeDifference += 2 * Math.PI
        areaSum += longitudeDifference * (2 + Math.sin(latitude) + Math.sin(nextLatitude))
      })
      return Math.abs(areaSum) > 0
    },
    isValidCoordinatePolyline(coordinates) {
      if (
        coordinates.length < 2 ||
        !coordinates.every(
          (point) =>
            Number.isFinite(Number(point.bujur)) &&
            Number(point.bujur) >= -180 &&
            Number(point.bujur) <= 180 &&
            Number.isFinite(Number(point.lintang)) &&
            Number(point.lintang) >= -90 &&
            Number(point.lintang) <= 90,
        )
      )
        return false

      let distance = 0
      coordinates.slice(1).forEach((point, index) => {
        const previous = coordinates[index]
        const toRadians = (degree) => (degree * Math.PI) / 180
        const latitudeDifference = toRadians(Number(point.lintang) - Number(previous.lintang))
        const longitudeDifference = toRadians(Number(point.bujur) - Number(previous.bujur))
        const latitude1 = toRadians(Number(previous.lintang))
        const latitude2 = toRadians(Number(point.lintang))
        const haversine =
          Math.sin(latitudeDifference / 2) ** 2 +
          Math.cos(latitude1) * Math.cos(latitude2) * Math.sin(longitudeDifference / 2) ** 2
        distance += 2 * 6371008.8 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine))
      })
      return distance > 0
    },
    indicatorIdentitasClass(form) {
      const textFields = [
        'nomor_kkprl',
        'jenis_kegiatan',
        'npwp',
        'subjek_hukum',
        'nama_kegiatan',
        'nama_detail_kegiatan',
        'luas',
        'panjang',
        'nama_perairan',
        'nama_kawasan_rtr',
        'dasar_hukum_rtr',
        'keterangan_realisasi',
      ]
      const hasRequiredText = textFields.every((field) => String(form[field] || '').trim() !== '')
      const hasNib = form.jenis_kegiatan !== 'Berusaha' || String(form.nib || '').trim() !== ''
      const hasProvinsi = Array.isArray(form.provinsi) ? form.provinsi.length > 0 : Boolean(form.provinsi)
      const file = form.bukti_dukung
      const hasPdf =
        Boolean(form.id_file_bukti_dukung) ||
        (file &&
          (file.type === 'application/pdf' ||
            String(file.name || '')
              .toLowerCase()
              .endsWith('.pdf')))
      const coordinatesComplete =
        form.titik_koordinat.length > 0 &&
        form.titik_koordinat.every(
          (point) =>
            String(point.bujur || '').trim() !== '' &&
            String(point.lintang || '').trim() !== '' &&
            ['Sesuai', 'Tidak Sesuai'].includes(point.observasi),
        )
      const isComplete =
        hasRequiredText && hasNib && hasProvinsi && Boolean(form.tanggal_terbit) && hasPdf && coordinatesComplete
      return isComplete ? 'text-success' : 'text-danger'
    },
    kembaliKeDaftar() {
      this.$router.push('/app/penilaian-pelaksanaan/pusat')
    },
    keTabSebelumnya() {
      this.$refs.formTabs.navigateTo(this.activeTab - 1)
    },
    keTabBerikutnya() {
      this.$refs.formTabs.navigateTo(this.activeTab + 1)
    },
    buildIdentitasFormData() {
      const identitas = this.form.identitas
      const formData = new FormData()

      if (this.idRencanaAksi) {
        formData.append('id_rencana_aksi', this.idRencanaAksi)
      }

      IDENTITAS_FIELDS.forEach((field) => {
        // NIB hanya dikirim saat jenis kegiatan Berusaha
        if (field === 'nib' && identitas.jenis_kegiatan !== 'Berusaha') {
          return
        }

        const value = identitas[field]

        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item === undefined || item === null || item === '') return
            formData.append(field, item)
          })
          return
        }

        if (value === undefined || value === null || value === '') {
          return
        }

        formData.append(field, value)
      })

      // hanya kirim file jika user memilih file baru, agar file lama tetap tersimpan saat update
      if (identitas.bukti_dukung instanceof File) {
        formData.append('file_bukti_dukung', identitas.bukti_dukung)
      }

      return formData
    },
    async saveIdentitas() {
      const id = this.$route.query.id_pelaksanaan_penilaian
      const url = id ? `api/pelaksanaan_penilaian/${id}` : 'api/pelaksanaan_penilaian'

      try {
        const res = await api.post(url, this.buildIdentitasFormData())
        const savedData = res.data?.data
        const savedId = savedData?.id || id

        if (savedData?.id_file_bukti_dukung) {
          this.form.identitas = {
            ...this.form.identitas,
            id_file_bukti_dukung: savedData.id_file_bukti_dukung,
          }
        }

        if (!id && savedId) {
          await this.$router
            .replace({
              path: this.$route.path,
              query: { ...this.$route.query, id_pelaksanaan_penilaian: savedId },
            })
            .catch(() => {})
        }

        return savedId
      } catch (error) {
        const message = error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data'
        Swal.fire('Gagal', message, 'error')
        return false
      }
    },
    async simpanIdentitasDanTitik() {
      const id = await this.saveIdentitas()
      if (!id) return false

      const isTitikSaved = await this.$refs.formIdentitas.simpanTitikKoordinat(id)
      await this.loadTitikKoordinat()
      if (!isTitikSaved) return false

      Swal.fire('Berhasil', 'Identitas dan titik koordinat tersimpan', 'success')
      return true
    },
    async konfirmasiPindahTab() {
      const tabKey = this.tabKeyByIndex[this.activeTab]
      if (!tabKey) return true

      const result = await Swal.fire({
        icon: 'question',
        title: 'Simpan draf bagian ini?',
        text: 'Draf bagian ini akan disimpan sebelum berpindah tab.',
        showCancelButton: true,
        confirmButtonText: 'Ya, Simpan',
        cancelButtonText: 'Batal',
      })

      if (!result.isConfirmed) return false
      return await this.simpanTab(tabKey)
    },
    async loadPelaksanaanPenilaian() {
      if (!this.idRencanaAksi) return

      try {
        const res = await api.get(`api/pelaksanaan_penilaian?filter=id_rencana_aksi,=,${this.idRencanaAksi}`)
        const data = res.data?.data?.[0]
        if (!data) return

        this.form.identitas = {
          ...this.form.identitas,
          nomor_kkprl: data.nomor_kkprl || '',
          jenis_kegiatan: data.jenis_kegiatan || '',
          npwp: data.npwp || '',
          subjek_hukum: data.subjek_hukum || '',
          nib: data.nib || '',
          provinsi: Array.isArray(data.provinsi) ? data.provinsi : data.provinsi ? [data.provinsi] : [],
          tanggal_terbit: data.tanggal_terbit || '',
          nama_kegiatan: data.nama_kegiatan || '',
          nama_detail_kegiatan: data.nama_detail_kegiatan || '',
          luas: data.luas === null || data.luas === undefined ? '' : String(data.luas),
          panjang: data.panjang === null || data.panjang === undefined ? '' : String(data.panjang),
          nama_perairan: data.nama_perairan || '',
          nama_kawasan_rtr: data.nama_kawasan_rtr || '',
          dasar_hukum_rtr: data.dasar_hukum_rtr || '',
          keterangan_realisasi: data.keterangan_realisasi || '',
          id_file_bukti_dukung: data.id_file_bukti_dukung || null,
        }

        this.form.kewajiban = {
          items: kewajibanItems.map((item) => ({
            id: item.id,
            hasil_penilaian: data[`hasil_penilaian_${item.id}`] || '',
            catatan_penilaian: data[`catatan_penilaian_${item.id}`] || '',
          })),
        }

        const buildWawancaraFromData = (key) => {
          const dataWawancara = createEmptyWawancaraNarasumber()
          const fields = WAWANCARA_FIELD_MAP[key]

          Object.entries(fields).forEach(([source, target]) => {
            dataWawancara[source] = data[target] || ''
          })

          dataWawancara.zona_waktu = data[fields.zona_waktu] || 'WIB'

          const pewawancara = data[`pewawancara_${key}`]
          dataWawancara.pewawancara = Array.isArray(pewawancara) ? pewawancara[0] || null : pewawancara || null

          wawancaraQuestionGroups.forEach((group) => {
            group.questions.forEach((question) => {
              const apiKey = question.apiKey || question.id
              dataWawancara.jawaban_pertanyaan[question.id] = {
                jawaban: data[`jawaban_${apiKey}_wawancara_${key}`] || '',
                penjelasan: data[`penjelasan_${apiKey}_wawancara_${key}`] || '',
              }
            })
          })

          return dataWawancara
        }

        this.form.wawancara = {
          pelaku_usaha: buildWawancaraFromData('pelaku_usaha'),
          masyarakat: buildWawancaraFromData('masyarakat'),
        }

        this.form.beritaAcara = {
          ...this.form.beritaAcara,
          tanggal_ba: data.tanggal_ba || '',
          nomor_ba: data.nomor_ba || '',
          provinsi: data.provinsi_ba || '',
          kabupaten: data.kabupaten_kota_ba || '',
          kecamatan: data.kecamatan_ba || '',
          kelurahan: data.kelurahan_ba || '',
          isi_berita_acara: data.isi_berita_acara || '',
        }

        this.form.finalisasi = {
          ...this.form.finalisasi,
          persentase_realisasi: this.toFormString(data.persentase_realisasi),
          kriteria: data.kriteria || '',
          kategori: data.kategori || '',
          luas_area_infrastruktur: this.toFormString(data.luas_area_infrastruktur),
          persentase_area_infrastruktur: this.toFormString(data.persentase_area_infrastruktur),
          luas_area_non_infrastruktur: this.toFormString(data.luas_area_non_infrastruktur),
          persentase_area_non_infrastruktur: this.toFormString(data.persentase_area_non_infrastruktur),
          kriteria_subjek_hukum: data.kriteria_subjek_hukum || '',
          kategori_subjek_hukum: data.kategori_subjek_hukum || '',
          kriteria_persetujuan: data.kriteria_persetujuan || '',
          kategori_persetujuan: data.kategori_persetujuan || '',
          kriteria_kewajiban_kkprl: data.kriteria_kewajiban_kkprl || '',
          kategori_kewajiban_kkprl: data.kategori_kewajiban_kkprl || '',
          hasil_penilaian: data.hasil_penilaian || '',
          catatan: data.catatan_finalisasi || '',
          tim_penilai: this.normalizeIdTimPenilai(data.id_tim_penilai),
        }

        await this.loadPenandatangan(data.id)

        if (!this.$route.query.id_pelaksanaan_penilaian) {
          await this.$router
            .replace({
              path: this.$route.path,
              query: { ...this.$route.query, id_pelaksanaan_penilaian: data.id },
            })
            .catch(() => {})
        }
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal memuat identitas penilaian pelaksanaan'
        Swal.fire('Gagal', message, 'error')
      }
    },
    toFormString(value) {
      return value === undefined || value === null ? '' : String(value)
    },
    normalizeIdTimPenilai(value) {
      const list = Array.isArray(value)
        ? value
        : typeof value === 'string' && value.trim() !== ''
        ? value.split(',')
        : []

      return list
        .map((item) => (item && typeof item === 'object' ? item.id : item))
        .map((item) => Number(item))
        .filter((item) => Number.isFinite(item) && item > 0)
    },
    async loadPenandatangan(idPelaksanaan) {
      if (!idPelaksanaan) return

      try {
        const response = await api.get(
          `api/penandatangan_ba?filter=id_pelaksanaan_penilaian,=,${idPelaksanaan}&sort=id,ASC`,
        )

        const list = (response.data?.data || []).filter(
          (item) => String(item.id_pelaksanaan_penilaian) === String(idPelaksanaan),
        )
        if (!list.length) return

        this.form.beritaAcara = {
          ...this.form.beritaAcara,
          penandatangan: list.map((item) => ({
            id: item.id,
            serverId: item.id,
            kategori: item.kategori || '',
            nama: item.nama || '',
            jabatan: item.jabatan || '',
            instansi_unit_kerja: item.instansi_unit_kerja || '',
          })),
        }
      } catch (error) {
        // biarkan data default; tidak perlu Swal saat load awal
      }
    },
    async loadLaporanTahunanIdentitas() {
      if (!this.idRencanaAksi) return

      try {
        const res = await api.get(`api/laporan_tahunan?filter=id_rencana_aksi,=,${this.idRencanaAksi}`)
        const data = res.data?.data?.[0]
        if (!data) return

        const identitas = { ...this.form.identitas }

        Object.entries(LAPORAN_TAHUNAN_IDENTITAS_FIELDS).forEach(([field, sumber]) => {
          let value = data[sumber]

          // provinsi selalu disimpan sebagai array
          if (field === 'provinsi') {
            if (Array.isArray(value)) {
              // sudah array, pakai apa adanya
            } else if (value) {
              value = [value]
            } else {
              value = []
            }
          }

          const isEmpty = (item) => {
            if (Array.isArray(item)) return item.length === 0
            return item === undefined || item === null || String(item).trim() === ''
          }

          // lewati jika data laporan kosong atau field sudah punya nilai
          if (isEmpty(value) || !isEmpty(identitas[field])) return

          identitas[field] = Array.isArray(value) ? value : String(value)
        })

        this.form.identitas = identitas
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal memuat data laporan tahunan'
        Swal.fire('Gagal', message, 'error')
      }
    },
    async loadTitikKoordinat() {
      const id = this.$route.query.id_pelaksanaan_penilaian
      if (!id) return

      try {
        const res = await api.get(`api/titik_koordinat_observasi?filter=id_pelaksanaan_penilaian,=,${id}&sort=id,ASC`)
        const points = (res.data?.data || []).map((row) => ({
          id: row.id,
          nama_titik: row.nama_titik === null || row.nama_titik === undefined ? '' : String(row.nama_titik),
          bujur: row.bujur === null || row.bujur === undefined ? '' : String(row.bujur),
          lintang: row.lintang === null || row.lintang === undefined ? '' : String(row.lintang),
          observasi: row.observasi_titik_pengendalian || '',
        }))

        this.form.identitas = { ...this.form.identitas, titik_koordinat: points }

        if (this.$refs.formIdentitas) {
          this.$refs.formIdentitas.syncSnapshotFromValue(points)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal memuat titik koordinat'
        Swal.fire('Gagal', message, 'error')
      }
    },
    async loadKemajuanPerizinan() {
      const id = this.$route.query.id_pelaksanaan_penilaian
      if (!id) return

      try {
        const pelaksanaanRes = await api.get(`api/pelaksanaan_penilaian/${id}`)
        const jenisArea = pelaksanaanRes.data?.data?.jenis_area || ''

        const perizinanRes = await api.get(`api/kemajuan_perizinan?filter=id_pelaksanaan_penilaian,=,${id}&sort=id,ASC`)
        const perizinan = perizinanRes.data?.data || []

        const koordinatRes = await api.get(
          `api/koordinat_perizinan_berusaha?filter=id_pelaksanaan_penilaian,=,${id}&sort=id,ASC`,
        )
        const koordinatRows = Array.isArray(koordinatRes.data?.data)
          ? koordinatRes.data.data
          : koordinatRes.data?.data
          ? [koordinatRes.data.data]
          : []

        const kemajuanPerizinan = {
          ...this.form.kemajuanPerizinan,
          jenis_area: jenisArea || this.form.kemajuanPerizinan.jenis_area,
          perizinan: perizinan.length ? perizinan : this.form.kemajuanPerizinan.perizinan,
          koordinat_perizinan: koordinatRows,
        }

        this.form.kemajuanPerizinan = kemajuanPerizinan

        if (this.$refs.formKemajuanPerizinan) {
          this.$refs.formKemajuanPerizinan.syncSnapshotFromValue(kemajuanPerizinan)
        }
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal memuat kemajuan perizinan'
        Swal.fire('Gagal', message, 'error')
      }
    },
    async loadInformasiKewajiban() {
      if (!this.idRencanaAksi) return

      try {
        const res = await api.get(`api/persiapan_penilaian?filter=id_rencana_aksi,=,${this.idRencanaAksi}`)
        const data = res.data?.data?.[0]
        if (!data) return

        this.informasiKewajiban = kewajibanItems.map((item) => ({
          id: item.id,
          deskripsi: data[`deskripsi_pemenuhan_${item.id}`] || '',
          id_file: Number(data[`id_file_pemenuhan_${item.id}`]) || 0,
        }))
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal memuat data pemenuhan kewajiban'
        Swal.fire('Gagal', message, 'error')
      }
    },
    buildWawancaraFormData() {
      const formData = new FormData()

      const appendIfFilled = (key, value) => {
        if (value === undefined || value === null || String(value).trim() === '') return
        formData.append(key, value)
      }

      const normalizeTime = (value) => {
        if (!value) return ''
        return /^\d{2}:\d{2}$/.test(value) ? `${value}:00` : value
      }

      Object.entries(WAWANCARA_FIELD_MAP).forEach(([key, fields]) => {
        const data = this.form.wawancara[key] || {}

        Object.entries(fields).forEach(([source, target]) => {
          const value = ['waktu_mulai', 'waktu_selesai'].includes(source) ? normalizeTime(data[source]) : data[source]
          appendIfFilled(target, value)
        })

        const pewawancara = data.pewawancara
        appendIfFilled(
          `pewawancara_${key}`,
          pewawancara === undefined || pewawancara === null ? '' : String(pewawancara),
        )

        wawancaraQuestionGroups.forEach((group) => {
          group.questions.forEach((question) => {
            const apiKey = question.apiKey || question.id
            const answer = (data.jawaban_pertanyaan || {})[question.id] || {}

            appendIfFilled(`jawaban_${apiKey}_wawancara_${key}`, answer.jawaban)
            appendIfFilled(`penjelasan_${apiKey}_wawancara_${key}`, answer.penjelasan)
          })
        })
      })

      return formData
    },
    async simpanWawancara() {
      const id = this.$route.query.id_pelaksanaan_penilaian
      if (!id) {
        Swal.fire('Gagal', 'Simpan data identitas terlebih dahulu', 'warning')
        return false
      }

      try {
        await api.post(`api/pelaksanaan_penilaian/${id}`, this.buildWawancaraFormData())
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan data wawancara'
        Swal.fire('Gagal', message, 'error')
        return false
      }
    },
    buildBeritaAcaraFormData() {
      const formData = new FormData()
      const data = this.form.beritaAcara || {}

      const appendIfFilled = (key, value) => {
        if (value === undefined || value === null || String(value).trim() === '') return
        formData.append(key, value)
      }

      Object.entries(BERITA_ACARA_FIELD_MAP).forEach(([source, target]) => {
        if (source === 'isi_berita_acara') {
          appendIfFilled(target, this.hasRichTextContent(data[source]) ? data[source] : '')
          return
        }

        appendIfFilled(target, data[source])
      })

      return formData
    },
    async simpanBeritaAcara() {
      const id = this.$route.query.id_pelaksanaan_penilaian
      if (!id) {
        Swal.fire('Gagal', 'Simpan data identitas terlebih dahulu', 'warning')
        return false
      }

      try {
        await api.post(`api/pelaksanaan_penilaian/${id}`, this.buildBeritaAcaraFormData())
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan berita acara'
        Swal.fire('Gagal', message, 'error')
        return false
      }
    },
    buildFinalisasiFormData() {
      const data = this.form.finalisasi || {}
      const formData = new FormData()

      FINALISASI_FIELDS.forEach((field) => {
        const value = data[field]
        if (value === undefined || value === null || String(value).trim() === '') return
        formData.append(field, value)
      })

      if (this.hasRichTextContent(data.catatan)) {
        formData.append('catatan_finalisasi', data.catatan)
      }

      if (Array.isArray(data.tim_penilai)) {
        data.tim_penilai.forEach((idUser) => {
          if (idUser === undefined || idUser === null || String(idUser).trim() === '') return
          formData.append('id_tim_penilai', idUser)
        })
      }

      return formData
    },
    async simpanFinalisasi() {
      const id = this.$route.query.id_pelaksanaan_penilaian
      if (!id) {
        Swal.fire('Gagal', 'Simpan data identitas terlebih dahulu', 'warning')
        return false
      }

      try {
        await api.post(`api/pelaksanaan_penilaian/${id}`, this.buildFinalisasiFormData())
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal menyimpan data finalisasi'
        Swal.fire('Gagal', message, 'error')
        return false
      }
    },
    async simpanTab(tabKey) {
      if (tabKey === 'identitas') {
        return await this.simpanIdentitasDanTitik()
      }

      if (tabKey === 'kemajuanPerizinan') {
        const berhasil = await this.$refs.formKemajuanPerizinan.simpanKemajuanPerizinan()
        await this.loadKemajuanPerizinan()
        if (!berhasil) return false

        Swal.fire('Berhasil', 'Kemajuan perizinan tersimpan', 'success')
        return true
      }

      if (tabKey === 'kewajiban') {
        const berhasil = await this.$refs.formKewajiban.simpanKewajiban()
        if (!berhasil) return false

        Swal.fire('Berhasil', 'Penilaian kewajiban tersimpan', 'success')
        return true
      }

      if (tabKey === 'wawancara') {
        const berhasil = await this.simpanWawancara()
        if (!berhasil) return false

        Swal.fire('Berhasil', 'Data wawancara tersimpan', 'success')
        return true
      }

      if (tabKey === 'beritaAcara') {
        const penandatanganBerhasil = await this.$refs.formBeritaAcara?.simpanPenandatangan()
        if (penandatanganBerhasil === false) return false

        const berkasBerhasil = await this.$refs.formBeritaAcara?.simpanBerkas()
        if (berkasBerhasil === false) return false

        const berhasil = await this.simpanBeritaAcara()
        if (!berhasil) return false

        Swal.fire('Berhasil', 'Berita acara tersimpan', 'success')
        return true
      }

      if (tabKey === 'finalisasi') {
        const berhasil = await this.simpanFinalisasi()
        if (!berhasil) return false

        Swal.fire('Berhasil', 'Data finalisasi tersimpan', 'success')
        return true
      }
    },
    async submitForm() {
      const tabChecks = [
        { name: 'Identitas', isComplete: this.indicatorIdentitasClass(this.form.identitas) === 'text-success' },
        {
          name: 'Kemajuan Perizinan',
          isComplete: this.indicatorKemajuanPerizinanClass(this.form.kemajuanPerizinan) === 'text-success',
        },
        { name: 'Kewajiban', isComplete: this.indicatorKewajibanClass(this.form.kewajiban) === 'text-success' },
        { name: 'Wawancara', isComplete: this.indicatorWawancaraClass(this.form.wawancara) === 'text-success' },
        { name: 'Berita Acara', isComplete: this.indicatorBeritaAcaraClass(this.form.beritaAcara) === 'text-success' },
        { name: 'Finalisasi', isComplete: this.indicatorFinalisasiClass(this.form.finalisasi) === 'text-success' },
      ]

      this.incompleteTabNames = tabChecks.filter((tab) => !tab.isComplete).map((tab) => tab.name)
      if (this.incompleteTabNames.length) {
        this.showIncompleteTabsModal = true
        return
      }

      const { isConfirmed, value: accept } = await Swal.fire({
        icon: 'question',
        title: 'Submit Penilaian?',
        text: 'Apakah Anda yakin ingin submit penilaian pelaksanaan ini?',
        input: 'checkbox',
        inputPlaceholder: 'Tindakan ini tidak bisa dibatalkan',
        showCancelButton: true,
        confirmButtonText: 'Ya, Submit',
        cancelButtonText: 'Batal',
        inputValidator: (result) => !result && 'Ceklis konfirmasi wajib disetujui',
      })
      if (!isConfirmed || !accept) return

      // Simpan data Finalisasi yang belum tersimpan sebelum status dikunci
      const finalisasiTersimpan = await this.simpanFinalisasi()
      if (!finalisasiTersimpan) return

      const id = this.idRencanaAksi
      if (!id) {
        Swal.fire('Gagal', 'ID Rencana Aksi tidak ditemukan', 'error')
        return
      }

      try {
        await api.post(`api/rencana_aksi/${id}`, { status: STATUS_RENCANA_AKSI.SELESAI })
        await Swal.fire('Berhasil', 'Penilaian pelaksanaan berhasil di-submit.', 'success')
        this.kembaliKeDaftar()
      } catch (error) {
        const message = error.response?.data?.message || 'Gagal submit penilaian pelaksanaan'
        Swal.fire('Gagal', message, 'error')
      }
    },
  },
}
</script>
